import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
export var addFullScreenListeners = function addFullScreenListeners(_ref) {
  var playerElement = _ref.playerElement,
    onFullscreenChange = _ref.onFullscreenChange;
  if (playerElement) {
    playerElement.addEventListener('fullscreenchange', onFullscreenChange);
    playerElement.addEventListener('mozfullscreenchange', onFullscreenChange);
    playerElement.addEventListener('MSFullscreenChange', onFullscreenChange);
    playerElement.addEventListener('webkitfullscreenchange', onFullscreenChange);
  }
};
export var removeFullScreenListeners = function removeFullScreenListeners(_ref2) {
  var playerElement = _ref2.playerElement,
    onFullscreenChange = _ref2.onFullscreenChange;
  if (playerElement) {
    playerElement.removeEventListener('fullscreenchange', onFullscreenChange);
    playerElement.removeEventListener('mozfullscreenchange', onFullscreenChange);
    playerElement.removeEventListener('MSFullscreenChange', onFullscreenChange);
    playerElement.removeEventListener('webkitfullscreenchange', onFullscreenChange);
  }
};
var _requestFullscreen = /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref3) {
    var playerElement;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          playerElement = _ref3.playerElement;
          if (!playerElement.requestFullscreen) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", playerElement.requestFullscreen());
        case 3:
          if (!playerElement.webkitRequestFullscreen) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return",
          // @ts-expect-error ('webkitRequestFullscreen' does not exist on type 'Document')
          playerElement.webkitRequestFullscreen());
        case 5:
          if (!playerElement.mozRequestFullScreen) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", playerElement.mozRequestFullScreen());
        case 7:
          if (!playerElement.msRequestFullscreen) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", playerElement.msRequestFullscreen());
        case 9:
          return _context.abrupt("return", new Promise(function (_resolve, reject) {
            return reject();
          }));
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function requestFullscreen(_x) {
    return _ref4.apply(this, arguments);
  };
}();
export { _requestFullscreen as requestFullscreen };
export var lockFullscreenOrientation = /*#__PURE__*/function () {
  var _ref6 = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref5) {
    var _window$screen, _window$screen$orient;
    var orientation;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          orientation = _ref5.orientation;
          if (!(// @ts-expect-error Property 'lock' does not exist on type 'ScreenOrientation'
          (_window$screen = window.screen) !== null && _window$screen !== void 0 && (_window$screen$orient = _window$screen.orientation) !== null && _window$screen$orient !== void 0 && _window$screen$orient.lock)) {
            _context2.next = 9;
            break;
          }
          _context2.prev = 2;
          _context2.next = 5;
          return window.screen.orientation.lock(orientation);
        case 5:
          _context2.next = 9;
          break;
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](2);
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 7]]);
  }));
  return function lockFullscreenOrientation(_x2) {
    return _ref6.apply(this, arguments);
  };
}();
export var exitFullScreen = /*#__PURE__*/function () {
  var _ref7 = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _window$screen2, _window$screen2$orien;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if ((_window$screen2 = window.screen) !== null && _window$screen2 !== void 0 && (_window$screen2$orien = _window$screen2.orientation) !== null && _window$screen2$orien !== void 0 && _window$screen2$orien.unlock) {
            try {
              window.screen.orientation.unlock();
            } catch (e) {
              // Could not unlock screen orientation
            }
          }
          if (!document.exitFullscreen) {
            _context3.next = 6;
            break;
          }
          _context3.next = 4;
          return document.exitFullscreen();
        case 4:
          _context3.next = 19;
          break;
        case 6:
          if (!document.webkitExitFullscreen) {
            _context3.next = 11;
            break;
          }
          _context3.next = 9;
          return document.webkitExitFullscreen();
        case 9:
          _context3.next = 19;
          break;
        case 11:
          if (!document.mozCancelFullScreen) {
            _context3.next = 16;
            break;
          }
          _context3.next = 14;
          return document.mozCancelFullScreen();
        case 14:
          _context3.next = 19;
          break;
        case 16:
          if (!document.msExitFullscreen) {
            _context3.next = 19;
            break;
          }
          _context3.next = 19;
          return document.msExitFullscreen();
        case 19:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function exitFullScreen() {
    return _ref7.apply(this, arguments);
  };
}();
export var isFullScreenActive = function isFullScreenActive() {
  var fullscreenElement = document.fullscreenElement ||
  // @ts-expect-error ('mozFullScreenElement' does not exist on type 'Document')
  document.mozFullScreenElement ||
  // @ts-expect-error ('webkitFullscreenElement' does not exist on type 'Document')
  document.webkitFullscreenElement;
  return !!fullscreenElement;
};